export default __webpack_public_path__ + "static/media/instagram.771d54e3.png";